import { Annotation, Dataset, Folder, FourDService, Job, JobBatch, ProcessorAPI, Transform, TransformGroup } from '4d-mapper';
import { AfterViewInit, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatDialog, MatSidenav, MatSnackBar } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { concatMap, debounceTime, take } from 'rxjs/operators';
import { AppService } from '../../commons/app.service';
import { APITypes } from '../../commons/global';

import { Subscription } from 'rxjs/Subscription';
import { AclService } from '../../commons/acl/acl.service';
import { AppBaseComponent } from '../../commons/AppBaseComponent';
import { MapService } from '../../commons/map.service';
import { MainService } from '../main.service';
import { AgroListComponent } from './list-views/3rd_party/agro.component';
import { ImageListManager } from './list-views/images.component';
import { InspectionComponent } from './list-views/inspect.component';
import { LayersListComponent } from './list-views/layers.component';
import { ProcessingComponent } from './list-views/processing.component';
// resizable elements (new)
import { ResizeEvent } from 'angular-resizable-element';
import { forkJoin } from 'rxjs/index';
import { Constants } from '../../commons/Constants';

import { UiStateEngine } from '../../commons/ui/state-engine';
import { EntityHelperService } from '../../service/entity-helper.service';
import { MeasurementHelperService } from '../../service/measurement-helper.service';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';
//import { GeoJsonViewer } from './detail-views/layers/geojson.component';

import { HangOnComponent } from '../../commons/dialogs/hang-on/hang-on.component';
import { PluginController } from '../../commons/plugins/plugin-controller';
import { PluginManagerService } from '../../service/plugin-manager.service';
import { MapDataService } from '../../v2/commons/map-data.service';
import { PPListComponent } from './list-views/3rd_party/pp.component';
// import { LibraryComponent } from './list-views/library/library.component';

import { animate, style, transition, trigger } from '@angular/animations';
import { SceneControllerService } from '@src/app/service/controllers/scene-controller.service';
import { CesiumMapService } from '@src/app/service/map-viewer.service';
import { XsAwait } from '@src/app/xs/controllers/await.class';
import { XsIncomingDataService } from '@src/app/xs/services/data/incoming-data.service';
import { XsCameraControllerComponent } from '@src/app/xs/services/ui/camera-controller/camera-controller.component';
import { XsSplitViewerComponent } from '@src/app/xs/services/ui/split-viewer/split-viewer.component';
import { TileProfilerComponent } from '@src/app/xs/services/ui/tile-profiler/tile-profiler.component';
import { UiManagerService } from '@src/app/xs/services/ui/ui-manager.service';
import { LoadingSpinner } from '../../commons/ui/loading-spinner';
import { FdmPlugin } from './../../commons/plugins/plugins';

const Cesium = (<any>window).Cesium;

export enum ClickDisplay {
  None = 0,
  Balloon = 1,
  Chevron = 2,
}

export interface MapClickHandler {
  clickedMap(movement, rightClick: boolean, checkedPosition): ClickDisplay;
}

export interface MapTab extends MapClickHandler {
  becameActive(mapComp: MapComponent);

  becameInactive(mapComp: MapComponent);
}

export interface ClickedCoord {
  position: any;
  positionCart: any;
  annotation?: Annotation;
  measurement?: Annotation;
  screenPoint?: any;
  screenHeight: any;
  entity: any;
  image?: Transform;

  projectId?: number;
  screenshotName?: string;
}

@Component({
  selector: 'map-comp',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss'],
  animations: [
    trigger('slideInOut', [
      transition(':enter', [
        style({ transform: 'translateX(-100%)', opacity: 0, height: 0 }),
        animate('0.3s 12ms ease-in-out', style({ transform: 'translateX(0%)', opacity: 1, height: '100%' })),
      ]),
      transition(':leave', [animate('0.3s 12ms ease-in-out', style({ transform: 'translateX(-100%)', opacity: 0, height: 0 }))]),
    ]),
    trigger('slideUpDown', [
      transition(':enter', [
        style({ transform: 'translateY(-100%)', opacity: 0.5, height: 0 }),
        animate('0.2s 12ms ease-in-out', style({ transform: 'translateY(0%)', opacity: 1, height: '100%' })),
      ]),
      transition(':leave', [animate('0.2s 12ms ease-in-out', style({ transform: 'translateY(-100%)', opacity: 0.5, height: 0 }))]),
    ]),
  ],
})
export class MapComponent extends AppBaseComponent implements OnDestroy, AfterViewInit, OnInit {
  debug: boolean = Constants.debug_off;

  // experimenting with new styles and new ways of using components for speed improvements
  newStyle: boolean = false;

  transformPlugins: PluginController = null;

  // old code starts here

  activeTab: string;
  activeTabObj: MapTab;
  activeDetails: MapClickHandler;

  // project: Project

  @ViewChild('detailsNav', { static: true }) detailsNav: MatSidenav;

  @ViewChild('cameraBookmarks', { static: true }) cameraBookmarks: XsCameraControllerComponent;

  @ViewChild('photosNav', { static: true }) photosNav: MatSidenav;
  @ViewChild('contextNav', { static: true }) contextNav: MatSidenav;

  @ViewChild('sidenav', { static: true }) sidenav: MatSidenav;
  @ViewChild('hangon', { static: true }) hangon: HangOnComponent;
  @ViewChild('canvas', { static: true }) canvas: any;
  @ViewChild('northCanvas', { static: true }) northCanvas: any;

  // our splitViewer component
  @ViewChild(XsSplitViewerComponent, { static: true }) splitViewer: XsSplitViewerComponent;
  @ViewChild(TileProfilerComponent, { static: true }) tileProfiler: TileProfilerComponent;

  @ViewChild(LayersListComponent, { static: true }) layerComp: LayersListComponent;
  @ViewChild(ProcessingComponent, { static: true }) processingComp: ProcessingComponent;
  // @ViewChild(LibraryComponent,    {static: true}) libraryComp: LibraryComponent;
  @ViewChild(InspectionComponent, { static: true }) inspectorComp: InspectionComponent;
  @ViewChild(ImageListManager, { static: true }) imageComp: ImageListManager;
  @ViewChild(AgroListComponent, { static: true }) agroComp: AgroListComponent;
  @ViewChild(PPListComponent, { static: true }) ppComp: PPListComponent;

  APITypes = APITypes;

  // our Cesium map viewer (where all the 3D action is)
  cesiumMapViewer: any = null;

  // cesium click handler
  handler: any;

  showBalloon: boolean = false;

  currentCoord: ClickedCoord;

  isFullScreenMode: boolean;
  fullscreenElement: any;
  measurementUnit: string;

  // @alex -> new features; just leave for now
  // viewContextMenu = false;
  // viewContextMenuFloating = false;
  viewPhotosLarge = false;
  // viewPhotoBucket = false;
  // viewLibraryTab = false;
  number_precission = 2;

  html_selector = null;

  refPin: any;
  annotationDataSource: any;

  // movement of the mouse
  movement: any;

  cameraLocked: boolean;
  flyingToLine: boolean;
  vertical_offset: any;
  pausePlaying = false;
  cancelPlaying = false;
  isPlaying: boolean = false;
  playingSpeed: number = 0.01;
  playingSpeedX: number = 1;
  repeatPlaying = false;
  currentPlayingTransform: any;

  generatingTransforms: number[] = [];

  // permissions / access
  // access: any = null;

  viewRoleChanger: number = 0;

  // tracks and manages the mode of the user interface (tabs, buttons, what to turn on and off, etc.)
  gui: any = { project_choices: [], scene_choices: [], scene_choices_deep: [], main_tab: [] };

  // an array of info_boxes for all sorts of uses, mostly floating labels
  infoBoxes: any[] = [];
  ghostlabelOneIdx = 51;
  ghostlabelTwoIdx = 52;

  // map and camera plugins
  mapPlugins: PluginController = null;
  cameraPlugins: PluginController = null;
  scenePlugins: PluginController = null;
  basemapPlugins: PluginController = null;

  // visual states
  showScenePlugins: boolean = false;

  currentMousePosition: any = null;

  uploadDragHover: boolean = false;
  dragDropControl(e, entering) {
    this.uploadDragHover = entering;
    e.preventDefault();
    e.stopPropagation();
  }

  // poor hack for showing Poisiton Partners demo (Yup, very poor :) ... AJ)
  isPP: ProcessorAPI;
  v2DataService: MapDataService;

  constructor(
    public fourD: FourDService,
    public service: AppService,
    public incomingData: XsIncomingDataService,
    public router: Router,
    public mappingHelper: MeasurementHelperService,
    public entityHelper: EntityHelperService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public permissions: AclService,
    public state_engine: UiStateEngine,
    private route: ActivatedRoute,
    public mapService: MapService,
    public mainService: MainService,
    public pluginManager: PluginManagerService,
    applicationEvents: XsApplicationEventsService,
    public uiManager: UiManagerService,
    public cesiumMapService: CesiumMapService,
    public sceneController: SceneControllerService
  ) {
    super(service, router, snackBar, dialog, applicationEvents);
    this.v2DataService = mapService.v2Maps;
    // let's make 50 empty info boxes for a variety of uses + a couple specific ones for ghostlabels (51, 52)
    for (let n = 0; n <= 50 + 2; n++) {
      this.infoBoxes.push({
        id: n,
        title: 'Info',
        text: '',
        holdStill: false,
        accent: false,
        show: false,
        coord: null,
        image: null,
        props: [],
      });
    }

    let me = this;

    // the main map plugins
    this.mapPlugins = this.pluginManager.createController('map-plugins', {
      filterByType: [FdmPlugin.types.mapController],
      createId: function (item: any) {
        return 'mp_' + item.id;
      },
    });

    // the basemap plugins
    this.basemapPlugins = this.pluginManager.createController('basemap-plugins', {
      filterByType: [FdmPlugin.types.basemapController],
      createId: function (item: any) {
        return 'bmp_' + item.id;
      },
      preRemove: function (pluginId: any) {
        me.basemapPlugins.component.close();
      },
    });

    // the main camera
    this.cameraPlugins = this.pluginManager.createController('camera-plugins', {
      filterByType: [FdmPlugin.types.cameraController],
      createId: function (item: any) {
        return 'cm_' + item.id;
      },
      preRemove: function (pluginId: any) {
        me.cameraPlugins.component.close();
      },
    });

    // our scene plugins
    this.scenePlugins = this.pluginManager.createController('scene', {
      label: 'Scene plugins',
      filterByType: [FdmPlugin.types.sceneController],
      createId: function (item: any) {
        return 's_' + item.id;
      },
      preRemove: function (pluginId: any) {
        me.scenePlugins.component.close();
      },
    });

    if (!this.transformPlugins && this.newStyle) {
      this.transformPlugins = this.pluginManager.createController('transforms', {
        filterByType: [FdmPlugin.types.transformController],
        filterByItemDsType: true,
        filterByItemTrType: true,
        createId: function (item: any) {
          return 't_' + item.id;
        },
        preRemove: function (pluginId: any, isDelete: boolean) {
          // if the popover is active, close it
          if (me.transformPlugins.component) {
            me.transformPlugins.component.close();
          }
        },
      });
    }

    // console.log('## controllers', this.basemapPlugins, this.cameraPlugins );
  }
  ngOnInit(): void {
    if (this.layerComp) {
      this.layerComp.splitViewer = this.splitViewer;
      this.layerComp.tileProfiler = this.tileProfiler;
    }

    super.ngOnInit();
  }
  ngOnDestroy() {
    this.mapService.v2Maps.clearProject();
    this.mapService.deinit();

    super.ngOnDestroy();
  }

  restartCesium(key: string = 'base') {
    let current = this.cesiumMapService.globes[key];
    this.sceneController.reportComplexAction('crash-detector::restart', { name: key, map: this.cesiumMapService.createReport(key) });
    this.sceneController.sendReport();
    if (current) {
      let c = current.canvas;
      let s = this.mapService.scene.id;
      this.mapService.helper.clearPlottables();
      this.cesiumMapService.destroy(key);
      this.cesiumMapService.init(key, c);
      setTimeout(() => {
        this.sceneController.plottedTransforms = [];
        this.sceneController.loadScene(s, true);
      }, 500);
    }
  }

  refreshBrowser(key: string = 'base') {
    this.sceneController.reportComplexAction('crash-detector::refresh', { name: key, map: this.cesiumMapService.createReport(key) });
    this.sceneController.sendReport();
    document.location.reload();
  }

  init() {
    if (this.debug) {
      console.log('map.comp :: init()');
    }

    // SJ this getting called before init for shared links
    this.v2DataService.onProjectReady().subscribe((_) =>
      // setup the state machine and access for the current role
      this.setupForRole()
    );
    // hide wait message
    Constants.showHangOn();

    // always listen out for scene tranfrom events
    this.addSubscription(
      'sceneTransformAdded',
      this.fourD
        .onSocketCommand('scene_transform_added')
        .pipe(debounceTime(3000))
        .subscribe((value) => {
          if (
            value.scene.id === this.mapService.scene.id &&
            !this.mapService.sceneTransforms.find((t) => value.transform && t.id == value.transform.id)
          ) {
            console.log('map.comp :: init() ADDED_TRANSFORM', value);
            this.mapService.loadScene(this.mapService.scene.id, true).subscribe();
          }
        })
    );

    // make sure the entity helper is set up early
    this.entityHelper.init();

    // event subscribe : access control changes
    // this.permissions.updatedAccess$.subscribe(tmp => {
    //   this.setupForRole();
    // });

    // progress updates (? @haresh)
    // further notes; this subject only fires from the main.component ... so, uploads only work if main is present
    // don't fully understand what it triggers, though. It's mad code!
    this.addSubscription(
      'datasetUploadTiling',
      this.mapService.datasetUploadingOrTilling.subscribe((_) => {
        this.checkUploadRunningOrTillingForDatasets();
        if (this.activeTab !== 'layers') {
          this.router.navigate([this.fourD.activeUser ? '/app/projects/map' : '/map', this.mapService.currentProject.id, 'layers']);
        }
      })
    );

    // listen to uploads (is this for starting, while, or done? @haresh)
    this.addSubscription(
      'uploadExisting',
      this.mainService.uploadExistingFiles.subscribe((_) => {
        this.layerComp.browseTT(this.mapService.scene);
      })
    );

    // Note: the idea is to put all of this into the incomingJobService, the below is for backwards compatiblility with old shitty code. Once
    // the new service handles everything we need, kill the below with fire! (and all associated arrays and objects and whatsnot)

    // listen to sockets for task_updates
    this.addSubscription(
      'taskUpdate',
      this.fourD.onSocketCommand('task_update').subscribe((value) => {
        this.checkSocketTaskUpdate(value);
      })
    );

    // listen to sockets for job_batch_updates
    this.addSubscription(
      'jobBatchUpdate',
      this.fourD
        .onSocketCommand('job_batch_update')
        .pipe(debounceTime(3000))
        .subscribe((value) => {
          // this.incomingData.jobUpdate(value);
          this.checkSocketJobBatchUpdate(value);
        })
    );
  }

  // listen out for when the mapViewer / CesiumMap is ready (ref; InterconnectedEventsInterface)
  ___mapViewer(obj: any = null) {
    if (this.debug) {
      console.log('%c map.component %c ___mapViewer', this.debugPrimary, this.debugSecondary, obj);
    }
    this.cesiumMapViewer = obj.viewer;
  }

  // ___mapViewerDestroyStart (obj:any = null ) {
  //   if ( this.debug ) { console.log ( '%c map.component %c ___mapViewerDestroyStart', this.debugPrimary, this.debugSecondary, obj ); }
  //   this.onDestroyMap();
  // this.cesiumMapViewer = null;
  // }

  // scene change about to start, so clear everything
  ___sceneChangeInit() {
    if (this.debug) {
      console.log('%c map.component %c ___sceneChangeInit', this.debugPrimary, this.debugSecondary);
    }
    if (this.scenePlugins) {
      this.scenePlugins.removeAll();
    }
    if (this.cameraPlugins) {
      this.cameraPlugins.removeAll();
    }
    if (this.basemapPlugins) {
      this.basemapPlugins.removeAll();
    }

    // if show/hide baseModel is set then apply it
    if (this.mapService.scene.hasOwnProperty('baseModel')) {
      // this.mapService.showBaseModel(this.mapService.scene['baseModel']);
      // console.log('## sceneChange() has_scene_base',this.mapService.scene['baseModel']);
    } else {
      //console.log('## sceneChange() no_scene_base',this.mapService.scene['baseModel']);
      this.mapService.scene['baseModel'] = true;
      //if ( this.mapService.currentProject.hasOwnProperty('baseModel') ) {
      //  this.mapService.scene['baseModel'] = this.mapService.currentProject['baseModel'];
      //  console.log('## sceneChange() has_project_base', this.mapService.currentProject['baseModel']);
      //}
    }
    //console.log('## sceneChange() final_scene_base',this.mapService.scene['baseModel']);
    this.mapService.showBaseModel(this.mapService.scene['baseModel']);

    if (this.newStyle) {
      // remove any plugins in the scene or on a transform
      this.transformPlugins.removeAll();
    }
  }

  ___sceneChangeError(error: any) {}

  // scene is starting to change, so load and init your stuff
  ___sceneChangeStart(scene: TransformGroup = null) {
    if (this.debug) {
      console.log('%c map.component %c __sceneChangeStart', this.debugPrimary, this.debugSecondary, scene.id);
    }

    if (this.cameraPlugins) {
      this.cameraPlugins.create('time-controller', { name: 'time-controller' }, this.mapService.currentProject);
      this.cameraPlugins.create('environment-controller', { name: 'environment-controller' }, this.mapService.currentProject);
      // console.log('## env plug', this.cameraPlugins);
    }

    if (this.basemapPlugins) {
      this.basemapPlugins.loadFrom(this.mapService.scene, this.mapService.scene.id);
    }

    // when a new scene, look for old crap we want to remove
    let shouldUpdate = false;
    let found = [];

    /* if ( scene['something'] ) {
      shouldUpdate = true;
      scene['something'] = null;
      found.push('something');
    } */

    if (shouldUpdate) {
      try {
        scene.saveObservable().subscribe(
          (yay) => {
            // console.log ( 'project ['+pid+'] updated / cleaned', p, found );
          },
          (boo) => {
            // console.log ( 'project ['+pid+'] updated / cleaned ERROR', p, found, boo );
          }
        );
      } catch (error) {
        console.log('scene [' + scene.id + '] updated / cleaned BIG ERROR', scene, found, error);
      }
    } else {
      // console.log ( 'project ['+pid+'] no cleaning', p, found );
    }

    if (this.scenePlugins) {
      this.scenePlugins.loadFrom(scene, scene.id);
    }

    this.setupForRole();
  }

  /*
  // scene change has ended, so fly to where we need to fly to ...
  ___sceneChangeProcess ( scene:TransformGroup = null ) {

    if ( this.debug ) { console.log ( '%c map.component %c __sceneChangeProcess', this.debugPrimary, this.debugSecondary, scene.id ); }

    let cam = this.sceneController.fetchCameraBookmark();
    if ( cam.camera ) {
      // console.log('################## item', cam );
      this.sceneController.registerAction( SceneActions.flyCamera, cam.camera );
    } else {
      let fromThese = this.mapService.sceneTransforms.filter ( t => this.mapService.scene['layerProps'][MapService.TOGGLE + t.id] );
      // console.log('################## find', fromThese );
      if ( fromThese ) {
        let t = fromThese[0];
        // console.log('################## first', t );
        if ( t ) {
          if ( t['ds_type_uid'] == 'kml' || t['ds_type_uid'] == 'geo-json' ) {
            this.sceneController.registerAction( SceneActions.flyCameraReady, t ); 
          } else {
            this.sceneController.registerAction( SceneActions.flyCamera, t ); 
          } 
        } else {
          // console.log('## letsFlyTo() missing Transform', fromThese, t );
        }
      }
    }
  }
*/

  // whenever a transform has unplotted itself from the map
  ___unplotTransformInit(t: any) {
    // console.log('%c **** ___T unplotting (should delete plugins first)', this._c, t.id, t );
    if (this.newStyle) {
      this.transformPlugins.removeAllFromItem(t);
    }
  }

  // whenever a transform has plotted itself on the map
  ___plotTransform(t: any) {
    // console.log('%c **** ___T plotted (loading from item)', this._c, t.id, t['__detected'] );

    // load in any plugins for the transforms (if saved to them)
    if (this.newStyle) {
      this.transformPlugins.loadFrom(t, this.mapService.scene.id);
    }
  }

  ngAfterViewInit() {
    this.fourD.onReady().subscribe((_) => {
      // subscribe to changes in route (meaning; loading of [new] project)
      this.route.params.subscribe((p) => {
        if (this.debug) {
          console.log('map.comp.ts :: ngAfterInit() route subscribe', p);
        }

        let sceneId = this.route.snapshot.queryParams['sceneId'];
        if (sceneId) {
          if (this.debug) {
            console.log('map.comp.ts :: ngAfterInit() route subscribe :: project and scene [sceneId]', sceneId);
          }
          this.loadProject(p['projId'], sceneId);

          if (this.route.snapshot.queryParams['addExistingData']) {
            this.openBrowseTTOfLayerComponent(+sceneId);
            if (this.debug) {
              console.log('map.comp.ts :: ngAfterInit() route subscribe :: openLayers');
            }
          }
        } else {
          if (this.debug) {
            console.log('map.comp.ts :: ngAfterInit() route subscribe :: only project');
          }
          this.loadProject(p['projId']);
        }
      });

      this.checkUploadRunningOrTillingForDatasets();
    });

    // don't think this is needed anymore
    // if (this.mapService.datasetForLayers.length > 0) {
    //   this.checkUploadRunningOrTillingForDatasets();
    // }
  }

  openCameraBookmarks() {
    if (this.cameraBookmarks) {
      this.cameraBookmarks.open();
    }
  }

  onDestroyMap() {
    if (this.debug) {
      console.log(' %c map.comp.ts :: onDestroyMap() ', Constants._red);
    }

    if (this.mapService.currentProject && this.cesiumMapViewer) {
      if (this.mapService.viewer.camera) {
        this.mapService.currentProject.transforms.queryParams = { limit: this.mapService.currentProject.transforms.queryParams.limit };
        if (!this.mapService.resetLastLocation) {
          // console.log('saving camera');
          const cam = this.sceneController.getCamera(); /* {
            position: this.cesiumMapViewer.camera.position,
            direction: this.cesiumMapViewer.camera.direction,
            up: this.cesiumMapViewer.camera.up,
            right: this.cesiumMapViewer.camera.right,
            // transform: this.camera.transform,
            // frustum: this.cesiumMapViewer.camera.frustum
          }; */
          this.mapService.currentProject.props['cameraPosition'] = cam;
          if (!this.mapService.currentProject['cameraPosition']) {
            this.mapService.currentProject['cameraPosition'] = cam;
          }
        }
      }
      if (this.mapService.scene) {
        if (this.debug) {
          console.log('saving last scene');
        }
        this.mapService.currentProject['lastActiveScene'] = this.mapService.scene.id;
      }
      // save the first transform's coordinates in the project to draw a pin in projectlist
      if (this.mapService.sceneTransforms && this.mapService.sceneTransforms.length > 0 && this.mapService.sceneTransforms[0].llng) {
        // console.log('saving coords');
        this.mapService.currentProject['firstTransformCoords'] = {
          llng: this.mapService.sceneTransforms[0].llng,
          llat: this.mapService.sceneTransforms[0].llat,
          lheight: this.mapService.sceneTransforms[0].lheight,
        };
      }
      this.mapService.currentProject.saveObservable().subscribe((r) => {
        if (this.debug) {
          console.log('saving project', this.mapService.currentProject, r);
        }
      });
    }
  }

  destroy() {
    if (this.debug) {
      console.log(
        'map.comp :: ngOnDestroy()',
        this.mapService.currentProject,
        this.cesiumMapViewer,
        this.mapService.resetLastLocation,
        this.mapService.scene
      );
    }

    // remove all plugins
    if (this.mapPlugins) {
      this.mapPlugins.removeAll();
      delete this.mapPlugins;
    }
    if (this.cameraPlugins) {
      this.cameraPlugins.removeAll();
      delete this.cameraPlugins;
    }
    if (this.basemapPlugins) {
      this.basemapPlugins.removeAll();
      delete this.basemapPlugins;
    }

    this.mapService.deinit();
    this.v2DataService.unload();
  }

  clickScenePluginShortcut(plugin: any, event: any = null) {
    let me = this;

    if (plugin.active) {
      // already running
      me.scenePlugins.component.open(plugin, me.mapService.scene, event);
    } else {
      // not running; start one up
      plugin.id = me.scenePlugins.create(plugin.name, null, me.mapService.scene);
      if (this.debug) {
        console.log('create_plugin', plugin.id);
      }

      setTimeout(() => {
        me.scenePlugins.component.open(plugin, me.mapService.scene, event);
      }, 200);
    }
  }

  setAllListsOffset() {
    var items = document.getElementsByClassName('fdm-sidebar-tabs-body');
    if (items) {
      for (var i = 0; i < items.length; i++) {
        let it = items[i];
        // console.log('@@OFFSET', it, this.showScenePlugins, this.showScenePlugins ? 'add' : 'remove' );
        if (this.showScenePlugins) {
          it.classList.add('open');
        } else {
          it.classList.remove('open');
        }
      }
    }
    // console.log('@@OFFSET', items );
  }

  toggleScenePlugins() {
    this.showScenePlugins = !this.showScenePlugins;
    this.setAllListsOffset();
  }

  toggleBucket() {
    this.viewPhotosLarge = !this.viewPhotosLarge;

    // just give CSS a bit of time to adjust
    setTimeout(() => {
      this.imageComp.refreshImageGroups(this.viewPhotosLarge);
    }, 90);
  }

  updateInfoBox(idx: number, obj: any) {
    let box = this.infoBoxes[idx];
    if (!box) {
      console.log('no box', idx, obj);
      return;
    }
    if (!obj) {
      return null;
    }
    if (obj.hasOwnProperty('show')) {
      box.show = obj.show;
    }
    if (obj.hasOwnProperty('accent')) {
      box.accent = obj.accent;
    }
    if (obj.hasOwnProperty('title')) {
      box.title = obj.title;
    }
    if (obj.hasOwnProperty('text')) {
      box.text = obj.text;
    }
    if (obj.hasOwnProperty('holdStill')) {
      box.holdStill = obj.holdStill;
    }
    if (obj.hasOwnProperty('coord')) {
      box.coord = obj.coord;
    }
    if (obj.hasOwnProperty('props')) {
      box.props = obj.props;
    }
    if (obj.hasOwnProperty('offset_y')) {
      box.offset_y = obj.offset_y;
    }
    if (obj.hasOwnProperty('image')) {
      box.image = obj.image;
    }
    this.infoBoxes[idx] = box;
    // console.log ( '@', box );
  }

  refreshInfoBoxes() {
    let pos = this.currentMousePosition;

    // should we show / update any infoboxes?
    let update = this.infoBoxes.filter((b) => {
      return b.coord ? b.show : false;
    });
    if (update && update.length > 0) {
      // console.log ( '!', update);
      update.forEach((element) => {
        let e = document.getElementById('info_box_' + element.id);
        if (e && element.coord) {
          if (element.accent) {
            e.classList.add('fdm-box-accent');
          } else {
            e.classList.remove('fdm-box-accent');
          }
          var canvasPosition = this.cesiumMapViewer.scene.cartesianToCanvasCoordinates(element.coord);

          if (Cesium.defined(canvasPosition)) {
            e.style.left = canvasPosition.x + 20 + 'px';
            e.classList.add('arrow-left');
            e.classList.remove('arrow-right');
            if (pos.x > canvasPosition.x && !element.holdStill) {
              e.style.left = canvasPosition.x - 220 + 'px';
              e.classList.add('arrow-right');
              e.classList.remove('arrow-left');
            }
            e.style.top = canvasPosition.y - 30 + (element['offset_y'] ? element['offset_y'] : 0) + 'px';
          }
          e.style.opacity = '1';
          e.style.visibility = 'visible';
        }
      });
    }
    let off = this.infoBoxes.filter((b) => {
      return !b.coord || !b.show;
    });
    if (off) {
      off.forEach((element) => {
        let e = document.getElementById('info_box_' + element.id);
        if (e) {
          e.style.opacity = '0';
          e.style.visibility = 'hidden';
          // e.style.top = '-500px';
          // e.style.left = '-500px';
        }
      });
    }
  }

  setupForRole() {
    /*
      This will be the first steps towards a new state machine for the UI where we can define behaviour and states of components. We'll
      build this out little by little, and we'll start with the two easiest entities; Widgets (which defines an area or location with interactions) and
      Features (which is the functionality, and has 1. a place to show the controller [ie. buttons, texts, links, etc.], and 2. a place to show the content)

    */

    // but first, grab a copy (or init) of the permissions
    // console.log('map.comp');
    // this.access = this.permissions.getAccess();

    // the mode of the user interface (renewed if the role changes)

    // start from scratch
    this.state_engine.reset();

    this.state_engine.addWidget('main_tab', {});

    // project stuff
    this.state_engine.addFeature('settings', {
      allowed: this.permissions.check('edit', 'project'),
      icon: 'cog',
      router: 'settings',
      tooltip: 'PROJECT.SETTINGS',
      showOptionIn: 'project_choices',
      showContentIn: 'details',
    });

    this.state_engine.addFeature('sharing', {
      allowed: this.permissions.check('share', 'project'),
      icon: 'users',
      router: 'shares',
      tooltip: 'PROJECT.SHARE',
      showOptionIn: 'project_choices',
      showContentIn: 'details',
    });

    this.state_engine.addFeature('camera_bookmarks', {
      allowed: true,
      icon: 'bookmark',
      tooltip: 'MAP.CAMERA_BOOKMARKS',
      title: 'MAP.CAMERA_BOOKMARKS',
      onclick: this.openCameraBookmarks,
      showOptionIn: 'scene_choices_deep',
      showContentIn: 'popup',
    });

    /*
    // used for debugging; you can turn a project new/recently_shared on and off)
    this.state_engine.addFeature('toggle_project', {
      allowed: true,
      icon: 'star',
      onclick: this.toggleProject,
      showOptionIn: 'project_choices',
      showContentIn: 'details'
    });
    */

    // scene stuff

    //* just need to move the functionality to a global space, and link it to this menu, and then remove the old menu from down in the layers ...
    this.state_engine.addFeature('scene_options', {
      allowed: this.permissions.check('create', 'scene'),
      icon: 'cog',
      menu: [
        { allowed: this.permissions.check('edit', 'scene'), icon: 'edit', label: 'SCENE.EDIT_NAME', onclick: this.renameScene },
        { allowed: this.permissions.check('edit', 'scene'), icon: 'camera', label: 'SCENE.CAMERA_VIEW', onclick: this.setSceneCameraView },
        {
          allowed: this.permissions.check('edit', 'scene'),
          icon: 'check-square',
          label: 'SCENE.SET_DEFAULT',
          onclick: this.setSceneAsDefault,
        },
        {
          allowed: this.permissions.check('delete', 'scene'),
          icon: 'trash',
          label: 'SCENE.DELETE_SCENE',
          onclick: this.deleteTransformGroup,
        },
      ],

      menu2: [
        { allowed: this.permissions.check('edit', 'scene'), icon: 'edit', label: 'SCENE.RENAME', onclick: null },
        { allowed: this.permissions.check('create', 'scene'), icon: 'folder-plus', label: 'SCENE.NEW', onclick: this.addScene },
        { allowed: this.permissions.check('delete', 'scene'), icon: 'times', label: 'SCENE.DELETE', onclick: null },
      ],
      tooltip: 'SCENE.OPTIONS',
      showOptionIn: 'scene_choices',
      showContentIn: 'popup',
    });

    this.state_engine.addFeature('create_scene', {
      allowed: this.permissions.check('create', 'scene'),
      icon: 'folder-plus',
      onclick: this.addScene, // dynamically passed in functions should always be to local functions (to the component)  to avoid insanely hard to find bugs
      tooltip: 'SCENE.NEW',
      showOptionIn: 'scene_choices',
      showContentIn: 'popup',
    });

    this.state_engine.addFeature('object_inspector', {
      allowed: true,
      icon: 'info',
      router: 'featureProperties',
      title: 'INSPECTOR.NAME',
      tooltip: 'INSPECTOR.NAME',
      showOptionIn: 'scene_choices_deep',
      showContentIn: 'popup',
    });

    // scene options (settings)
    /* this.state_engine.addFeature ( 'scene_options', {
        allowed: this.permissions.check('create','scene'),
        menu: [
          { allowed: this.permissions.check('edit','scene'), icon: 'edit', label: 'SCENE.EDIT_NAME'},
          { allowed: this.permissions.check('edit','scene'), icon: 'camera', label: 'SCENE.CAMERA_VIEW'},
          { allowed: this.permissions.check('edit','scene'), icon: 'check-square', label: 'SCENE.SET_DEFAULT'},
          { allowed: this.permissions.check('delete','scene'), icon: 'trash', label: 'SCENE.DELETE_SCENE' }
        ],
        tooltip: 'SCENE.OPTIONS',
        showOptionIn: 'scene_choices',
        showContentIn: 'popup'
      }); */

    // tabs
    this.state_engine.addFeature('plugin_agronomeye', {
      id: 'agro',
      // title: 'Agro',
      allowed: this.permissions.check('see', 'plugin_agronomeye'),
      icon: 'wheat',
      router: 'agro',
      showOptionIn: 'main_tab',
    });

    this.state_engine.addFeature('layers', {
      id: 'layers',
      title: 'TOOLBAR.LAYERS',
      showCount: true,
      allowed: this.permissions.check('see', 'layer'),
      // icon: 'layer-group',
      tooltip: 'TOOLBAR.LAYERS_TOOLTIP',
      router: 'layers',
      showOptionIn: 'main_tab',
    });

    this.state_engine.addFeature('tools', {
      id: 'annot',
      title: 'TOOLBAR.ANNOTATIONS',
      // icon: 'toolbox',
      showCount: true,
      allowed: this.permissions.check('see', 'annotations'),
      tooltip: 'TOOLBAR.ANNOTATIONS_TOOLTIP',
      router: 'annot',
      showOptionIn: 'main_tab',
    });

    this.state_engine.addFeature('processing', {
      id: 'processing',
      title: 'TOOLBAR.PROCESSING',
      // icon: 'toolbox',
      allowed: this.permissions.check('see', 'processing'),
      tooltip: 'TOOLBAR.PROCESSING_TOOLTIP',
      router: 'processing',
      showOptionIn: 'main_tab',
    });

    /* moved into the new WMS upload dialog
    this.state_engine.addFeature('library', {
      id: 'library',
      title: 'TOOLBAR.LIBRARY',
      // icon: 'toolbox',
      allowed: this.permissions.check('see', 'library'),
      tooltip: 'TOOLBAR.LIBRARY_TOOLTIP',
      router: 'library',
      showOptionIn: 'main_tab'
    }); */

    this.state_engine.addFeature('photos', {
      id: 'image',
      title: 'TOOLBAR.PHOTOS',
      // icon: 'camera',
      showCount: true,
      allowed: this.permissions.check('see', 'photos'),
      tooltip: 'TOOLBAR.PHOTOS_TOOLTIP',
      router: 'image',
      showOptionIn: 'popup',
    });

    // assign a local version of the UI state machine
    this.gui.project_choices = this.state_engine.getWidget('project_choices');
    this.gui.scene_choices = this.state_engine.getWidget('scene_choices');
    this.gui.scene_choices_deep = this.state_engine.getWidget('scene_choices_deep');
    this.gui.main_tab = this.state_engine.getWidget('main_tab');

    // console.log ( 'aaaaa', this.gui, this.state_engine );
  }

  // local function makes dynamic onclick events not screw up the 'this' reference in other component
  // ! we need to make sure all calls are local to the component to avoid these kind of deep bugs (and
  // it's good practice to keep getters, setters and handlers local to the component unless you really
  // have to, and when you really have to, make sure it's a friggin' module or service) (@alex)

  addScene() {
    if (this.layerComp) {
      this.layerComp.addTransformGroup();
    } else {
      console.error('Seems the layers list is missing?', this.layerComp);
    }
  }

  renameScene() {
    const item = this.mapService.scene;
    const me = item.name;
    this.openDialog('SCENE.RENAME', null, 'GENERIC.SAVE', 'GENERIC.CANCEL', me).subscribe((res) => {
      if (res) {
        item.name = res;
        item.saveObservable().subscribe();
      }
    });
  }

  setSceneCameraView() {
    if (this.mapService.scene) {
      this.mapService.scene['cameraPosition'] = this.sceneController.getCamera();
      this.mapService.scene.saveObservable().subscribe((_) => {
        console.log('@@saved_scene', this.mapService.scene);
      });
    }
  }

  setSceneAsDefault() {
    if (this.mapService.scene) {
      this.mapService.currentProject['lastActiveScene'] = this.mapService.scene.id;
      this.mapService.currentProject.saveObservable().subscribe();
    }
  }

  deleteTransformGroup() {
    const tg = this.mapService.scene;
    this.openConfirmDelete(
      () =>
        this.mapService.deleteScene(tg).subscribe((value) => {
          this.openSnackBarSuccess('GENERIC.DELETE');
        }),
      tg.name
    );
  }

  sceneOptions(me: any) {
    console.log('@@@@@@@', me);
  }

  toggleProject() {
    if (!this.mapService.currentProject.props.hasOwnProperty('isNew')) {
      this.mapService.currentProject.props['isNew'] = false;
    }
    this.mapService.currentProject.props['isNew'] = !this.mapService.currentProject.props['isNew'];
    this.mapService.currentProject.saveObservable().subscribe();
  }

  // resizing the navbar :: end
  onResizeEnd(event: ResizeEvent): void {
    // console.log('Element was resized', event);
    // console.log ( this.)
  }

  // just for updating alex code to latest code.
  loadProject(pid: number, sceneId?: number) {
    if (this.debug) {
      console.log('map.comp :: loadProject( pid, sceneId )', pid, sceneId);
    }

    // if a scene reference is passed through the router parameters, we know this is a shared link,
    // and so we'll try to load the scene given
    if (this.route.snapshot.queryParams['activeSceneId']) {
      sceneId = this.route.snapshot.queryParams['activeSceneId'];
    }

    // hang on a minute ...
    Constants.showHangOn();

    XsAwait.until('mapService.viewer', this).then((_) => {
      // console.log('@@@@@@@@@@@@ map.comp :: loadProject() @@@@@@@@@@@@@@@@ THESE are OK', theseOnes );

      this.cesiumMapViewer = this.mapService.viewer;

      this.loadProjectSubscription(pid, sceneId);
    });
  }

  loadProjectSubscription(pid: number, sceneId?: number) {
    this.addSubscription(
      'loadProject',

      this.mapService
        .loadProject(pid, sceneId)
        .pipe(concatMap((_) => this.v2DataService.loadProject(pid, sceneId)))
        .subscribe((p) => {
          this.setAllListsOffset();

          // console.log ( 'mapComponent @@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', this.mapService.currentProject['baseModel'] );

          if (this.debug) {
            console.log('map.comp :: loadProject() => subscribe.mapService.loadProject()', p);
          }

          // some hacky tests
          this.isPP = this.fourD.apis.find(
            (a) =>
              this.fourD.activeTeam &&
              a.account &&
              a.processorImpl == APITypes.PositionPartners.IMPL &&
              a.account.id == this.fourD.activeTeam.id
          );

          // update / refresh the list of annotations
          this.mapService.refreshAnnotations().subscribe();

          //change last used date
          p.saveObservable().subscribe((value) => {
            value.fetchObservable().subscribe();
          });

          // make an datasource for the cursor pin
          this.annotationDataSource = new Cesium.CustomDataSource('inspect_annot');
          this.cesiumMapViewer.dataSources.add(this.annotationDataSource);

          // setup refPin that appears wherever you click
          var pin = {
            name: 'crosshair pin',
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            disableDepthTestDistance: 15000,
            billboard: {
              image: InspectionComponent.getPinImg('crosshairs', 'red', 50),
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              disableDepthTestDistance: Number.POSITIVE_INFINITY,
            },
          };
          this.refPin = this.annotationDataSource.entities.add(pin);
          LoadingSpinner.end();
          // make local ref for camrea
          // this.camera = this.cesiumMapViewer.camera

          if (this.debug) {
            console.log('map_comp.ts :: loadProject() :: [' + this.constructor.name + '] NOW CONTROL THE MOUSE EVENTS ');
          }

          // connect mouse click events
          this.handler = new Cesium.ScreenSpaceEventHandler(this.cesiumMapViewer.canvas);

          // the right/left click handler can show a balloon callout for applicable fields
          this.handler.setInputAction((movement) => this.handleClick(movement, true), Cesium.ScreenSpaceEventType.RIGHT_CLICK);

          this.handler.setInputAction((movement) => this.handleClick(movement, false), Cesium.ScreenSpaceEventType.LEFT_CLICK);

          // set up mouse movement handler
          // this is the main place for mouse brdging between 4DM and Cesium
          this.handler.setInputAction((movement) => {
            this.currentMousePosition = movement.endPosition;
            this.mappingHelper.checkMousePosition(movement);
            this.refreshInfoBoxes();
          }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);

          if (p['measurementUnit']) {
            this.measurementUnit = p['measurementUnit'];
          }

          if (p['number_precission']) {
            this.number_precission = p['number_precission'];
          }

          // for sharing project with camera position
          if (this.route.snapshot.queryParams && this.route.snapshot.queryParams['camera']) {
            let x = JSON.parse(atob(this.route.snapshot.queryParams['camera']));

            let dest = Cesium.Cartographic.toCartesian(
              Cesium.Cartographic.fromDegrees(x['position']['lng'], x['position']['lat'], x['position']['height'])
            );
            let heading = Cesium.Math.toRadians(x['direction']['heading']);
            let pitch = Cesium.Math.toRadians(x['direction']['pitch']);
            let roll = Cesium.Math.toRadians(x['direction']['roll']);
            let orientation = {
              heading: heading,
              pitch: pitch,
              roll: roll,
            };
            let old = {
              heading: Cesium.Math.toRadians(x['direction']['heading']),
              pitch: Cesium.Math.toRadians(x['direction']['pitch']),
              roll: Cesium.Math.toRadians(x['direction']['roll']),
            };
            let big = { duration: 5, destination: dest, orientation: orientation };

            if (this.debug) {
              console.log('%c map.comp :: loadProject() :: VIEWLINK camera positions', Constants._red, x, big, old);
            }

            if (this.cesiumMapViewer) {
              this.cesiumMapViewer.camera.flyTo(big);
            }

            // old code based on query parameters; now we should use the Client objects camera (passed to here through the Route query parameters from oauth.component.ts)

            /* let [pos, dir] = this.route.snapshot.queryParams['camera'].split(',');
          let position = pos.split(';');
          let direction = dir.split(';');
          this.mapService.viewer.camera.flyTo({
            destination: Cesium.Cartographic.toCartesian(Cesium.Cartographic.fromDegrees(position[0], position[1], position[2])),
            duration: 5,
            orientation: {
              heading: Cesium.Math.toRadians(direction[0]),
              pitch: Cesium.Math.toRadians(direction[1]),
              roll: Cesium.Math.toRadians(direction[2])
            }
          }); */
          } else {
          }

          if (this.debug) {
            console.log('map.comp :: loadProject() DONE -------------------------------------------------- ', Cesium);
          }
          // }, 2000);
        })
    );
  }

  setTab(tab: string) {
    if (this.debug) {
      console.log('map.comp :: setTab(' + tab + ')');
    }

    // hack; until we turn imageComponent into a non-tab component, just return and do nothing if called
    if (tab == 'image') {
      this.openPhotoBucket();
      return null;
    }

    // its same tab do noting
    // when inside layer tab this subscriber is called and somehow the tab parameter is annot which is wrong so commenting below line. NOTE: this happens sometime only...
    if (this.activeTab == tab) return;
    // if old one de-init
    // if (this.activeTabObj)
    //   this.activeTabObj.becameInactive(this)

    this.activeTab = tab;

    // be sure to add your tabulated component here
    this.activeTabObj = {
      agro: this.agroComp,
      pp: this.ppComp,
      layers: this.layerComp,
      annot: this.inspectorComp,
      processing: this.processingComp,
      // 'library': this.libraryComp
    }[tab];

    let passAlong = null;
    if (tab !== 'library') {
      passAlong = this;
    }
    if (this.debug) {
      console.log('map.comp :: setTab(' + tab + ') mapService.onReady()', this.activeTabObj, passAlong);
    }

    //init tab
    if (this.activeTabObj) {
      if (this.debug) {
        console.log('map.comp :: setTab(' + tab + ') setActiveTabObj.becameActive()', tab);
      }
      this.activeTabObj.becameActive(passAlong);
    }

    // })
  }

  /**
   *
   * @param event This is an invisible pane display when the baollon callout is sowing clicking it should absorb the click event and dismiss the balloon
   * @param updateCalled
   * @param cantCloseSideNav1
   */
  absorb(event?: Event, updateCalled?: true, cantCloseSideNav1?: boolean) {
    this.showBalloon = false;
    this.detailsNav.close();
    if (event) {
      event.preventDefault();
    }

    return false;
  }

  handleClick(movement, isRightClick) {
    // this.debug = true;

    // let's check what's been clicked
    let check = this.mappingHelper.checkMousePosition(movement, true);

    if (this.debug) {
      console.log('map.comp.ts :: handleClick() ', movement, isRightClick, check);
    }

    // if current coordinates are passed through, update our local reference
    if (check.currentCoord) {
      this.currentCoord = check.currentCoord;
    }

    if (check.plugin) {
      if (this.debug) {
        console.log('@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@@', check.plugin);
      }

      let plug = this.pluginManager.get(check.plugin._plugin_id);
      if (plug) {
        plug.enter(check.plugin._plugin_id);
      }
      return ClickDisplay.None;
    }

    // has the 'thing' got a vertical offset on it?
    this.vertical_offset = check.vertical_offset;

    if (this.debug) {
      console.log('map.comp.ts :: handleClick() ', check);
    }

    // start with 0 (None)
    var lastClickDisplay: ClickDisplay = 0;

    // is there some details window open? And is there an obj reference to the component that's currently occupies it?
    if (this.detailsNav.opened && this.activeDetails) {
      if (this.debug) {
        console.log('map.comp :: handleClick() :: passing clicks on to active Details component', this.activeDetails);
      }

      // pass traffic on to them (I think this is mostly the Feature key/value component?)
      lastClickDisplay = this.activeDetails.clickedMap(movement, isRightClick, check);

      // return nothing, unless we're the GeoJsonViewer
      // if(!(this.activeDetails instanceof GeoJsonViewer))
      //  return ClickDisplay.None;

      // else, is there an active tab?
    } else if (this.activeTabObj) {
      // NOTE: refactored code; removed must of the stuff, replaced with check.* object instead

      // if the Images component isn't active, and we've clicked a feature
      if (!(this.activeTabObj instanceof ImageListManager) && check.feature) {
        if (this.debug) {
          console.log('map.comp :: handleClick() :: activeTab, but we could have clicked a feature/Annotation. Found any?', check.props);
        }

        if (check.props) {
          // console.log ( "@@@@@" ) ;
          // every existing feature has an annotation reference
          // this.inspectorComp.setSelected( this.mapService.annotations.find(a => a.id == check.props.annotationRef) );

          let newSelect = this.mapService.annotations.find((annotation) => annotation.id == check.props.annotationRef);

          if (this.debug) {
            console.log('map.comp :: handleClick() :: newSelect', newSelect, check.props.annotationRef);
          }

          if (newSelect) {
            // console.log ( '!!!!!!!!!!!!!!!!!!!!', newSelect);
            newSelect['entityRef'] = check.feature.id;
            newSelect['shapeRef'] = check.props.shapeRef;
            this.inspectorComp.setSelected(newSelect, true, 'map:handleClick()');
            // console.log ( '2 !!!!!!!!!!!!!!!!!!!!', newSelect);
          }
        } else {
          if (this.debug) {
            console.log('map.comp :: handleClick() :: no props', check.feature.transform_id, check.feature._transform_id);
          }

          // this means an image
          if (check.feature._transform_id) {
            this.imageComp.clickOnImage(check.feature);
          } else {
            lastClickDisplay = this.activeTabObj.clickedMap(movement, isRightClick, check);
          }

          // console.log ( "!!!!!", this.activeTabObj);
          // must be a new one
        }
      } else {
        if (this.debug) {
          console.log('map.comp :: handleClick() :: passing clicks on to active Tab component', this.activeTabObj);
        }

        // pass click on to the active tab
        lastClickDisplay = this.activeTabObj.clickedMap(movement, isRightClick, check);
      }
    } else {
      if (this.debug) {
        console.log('map.comp :: handleClick() :: No details view, no active tab.');
      }
    }

    // if you get here, I'm assuming it's dealing with the cursor/crosshair thingy?
    if (this.debug) {
      console.log('map.comp :: handleClick() :: cursor handling');
    }

    // this code is fucked up. Can we please re-factor this into something that's sane and less error-prone? (@alex)
    //[Adam] need to set the refPin.show to false if we are creating measurements and drawings BUT cound't figure out how! Alex?
    this.showBalloon = lastClickDisplay == ClickDisplay.Balloon;
    this.refPin.show = lastClickDisplay == ClickDisplay.Chevron || this.showBalloon;

    // are we using the context menu?
    //if (this.fourD.activeUser['showContextMenu']) {

    //if ( this.debug ) { console.log ( '%c map.comp %c handleClick() :: contextMenu', Constants._purple, Constants._orange, this.fourD.activeUser['showContextMenu'], document.getElementById('fdm-context-menu') ); }

    // is the context menu fixed or floating?
    //if (this.fourD.activeUser['showContextMenuFloating']) {

    // get the context menu (HTML section in the DOM)
    //var sel = document.getElementById('fdm-context-menu');

    //if (sel) {

    // update the HTML selector positions with new coords
    // sel.style.top = movement.position.y - 40 + 'px';
    // sel.style.left = movement.position.x + 40 + 'px';

    //}

    // }

    // open it
    //  this.contextNav.open();

    //}

    if (!(this.activeTabObj instanceof InspectionComponent)) {
      if (!this.refPin.show && this.cameraLocked) {
        this.cameraLocked = false;
      }

      if (!this.cameraLocked) {
        // change red pin location if camera is not locked
        if (this.debug) {
          console.log('%c map.comp %c handleClick() :: update crosshair cursor', Constants._purple, Constants._orange);
        }
        this.refPin.position = check.coords;

        if (this.imageComp.onlySelectedPositionPhotos) {
          this.imageComp.refreshPhotosFromCurrentCoord(check.coords, check);
        }
      }
    }

    this.cesiumMapViewer.selectedEntity = null;
    this.movement = movement;

    return ClickDisplay.None;
  }

  deleteScreenShot() {
    this.service.V.api('/api/Annotation/' + this.currentCoord.annotation.id + '/' + this.currentCoord.screenshotName, 'delete').subscribe(
      (value) => {
        this.currentCoord.screenshotName = undefined;
      }
    );
  }

  public getFeetValue(value: any) {
    if (this.measurementUnit === MapService.FEET) {
      // FEET to meters = 0.3048
      value = value / 0.3048;
    }
    return value;
  }

  checkUploadRunningOrTillingForDatasets(ds?: Dataset[]) {
    if (this.debug) {
      console.log('%c map.comp %c checkUploadRunningOrTillingForDatasets() LIST_OF_DATASETS', Constants._purple, Constants._orange, ds);
    }

    if (ds) {
      ds.forEach((d) => {
        // if (this.fourD.uploadsRunningMap[d.id]) {
        let index = this.mapService.datasetForLayers.findIndex((dd) => dd.id === d.id);
        if (index === -1 && d.dataType.uid != 'photo') {
          this.mapService.datasetForLayers.push(d);
        } else {
          // update the latest dataset
          this.mapService.datasetForLayers[index] = d;
        }
        // }
      });
    }
    if (this.mapService.datasetForLayers.length > 0) {
      // console.log(this.fourD.runningTasks);
      if (this.fourD.runningTasks.length > 0 && this.mapService.datasetForLayers.length !== this.generatingTransforms.length) {
        this.fourD.runningTasks.forEach((task) => {
          if (
            this.generatingTransforms.findIndex((id) => id === task.dataset.id) === -1 &&
            (task.dataset.name.endsWith('.laz') ||
              task.dataset.name.endsWith('.las') ||
              task.dataset.name.endsWith('.e57') ||
              task.dataset.name.endsWith('.obj'))
          ) {
            this.generatingTransforms.push(task.dataset.id);
          }
        });
      }
      // this.waitForTransformToBeReady();
    }

    if (this.debug) {
      console.log(
        '%c map.comp %c checkUploadRunningOrTillingForDatasets()',
        Constants._purple,
        Constants._orange,
        this.generatingTransforms,
        this.mapService.datasetForLayers
      );
    }

    this.addSubscription(
      'uploadsRunning',
      this.fourD.uploadsRunningObservable
        // .pipe(debounceTime(3000))
        .subscribe((s) => {
          if (s.finished) {
            if (this.mapService.datasetForLayers.length > 0) {
              let index = this.mapService.datasetForLayers.findIndex((d) => d.id === s.task.dataset.id);
              if (index !== -1) {
                // to update the incomplete status replace the updated dataset in the list.
                // this.mapService.datasetForLayers[index] = s.task.dataset;
                this.mapService.datasetForLayers[index].fetchObservable().subscribe();
                // this.mapService.datasetForLayers[index].incomplete = false;
              }
            }
          }
        })
    );
  }

  /* private waitForTransformToBeReady() {
    this.addSubscription('taskUpdate',this.fourD.onSocketCommand('task_update').subscribe(value => {
      this.checkSocketTaskUpdate(value);
    }));
    this.addSubscription('jobBatchUpdate',this.fourD.onSocketCommand('job_batch_update')
      .pipe(debounceTime(3000))
      .subscribe(value => {
        this.checkSocketJobBatchUpdate(value);
      }));
  } */

  private checkSocketJobBatchUpdate(value: any) {
    if (this.debug) {
      console.log('%c map.comp %c checkSocketJobBatchUpdate()', Constants._purple, Constants._orange, value);
    }
    if (!value.job_id) return;
    let datasetForLayersIndex = this.mapService.datasetForLayers.findIndex((d) => d['currentJob'] === value.job_id);
    if (
      value &&
      datasetForLayersIndex !== -1 &&
      (value.info.toLowerCase() === 'finished' ||
        value.status.toLowerCase() === 'finished' ||
        value.info.toLowerCase() === 'failed' ||
        value.status.toLowerCase() === 'failed')
    ) {
      if (this.debug) {
        console.log('%c map.comp %c checkSocketJobBatchUpdate() status', Constants._purple, Constants._orange, value);
      }

      if (!(value.info.toLowerCase() === 'failed' || value.status.toLowerCase() === 'failed')) {
        this.fourD.V.searchByObject(JobBatch)
          .equals('id', value.id)
          .limit(980)
          .queryObservable()
          .subscribe((res) =>
            res.items[0].outputs.queryObservable().subscribe(
              (files) => {
                if (files.items && files.items.length > 0) {
                  this.fourD.V.searchByObject(Transform)
                    .equals('input', files.items[0].id)
                    .limit(981)
                    .queryObservable()
                    .subscribe((res) => {
                      if (res.items.length > 0) {
                        // add the result as a child of the current scene if it is active
                        if (
                          this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group'] &&
                          this.mapService.scene.id === this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group']
                        ) {
                          this.mapService.scene.addChildren(res.items).subscribe((_) => {
                            this.removeFromDatasetForLayers(datasetForLayersIndex);
                            if (this.mapService.scene) {
                              // to refresh the photo count once the upload is finished
                              this.mapService.scene.fetchObservable().subscribe();
                              this._loadScene(this.mapService.scene.id, true);
                            }
                          });
                        } else if (this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group']) {
                          // the result is for other scene so add it to that scene

                          console.log('%c map.comp %c checkSocketJobBatchUpdate() status', Constants._purple, Constants._orange, value);

                          this.fourD.V.searchByObject(TransformGroup)
                            .equals('id', this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group'])
                            .limit(982)
                            .queryObservable()
                            .subscribe((tg) => {
                              if (tg.items.length > 0) {
                                tg.items[0].addChildren(res.items).subscribe();
                              }
                            });
                        }
                      }
                    });
                } else {
                  this.openSnackBarError('MAP.PHOTOGRAM.JOB_RESULT');
                  this.removeFromDatasetForLayers(datasetForLayersIndex);
                }
              },
              (error1) => {
                this.openSnackBarError('MAP.PHOTOGRAM.JOB_ERROR', error1);
                this.removeFromDatasetForLayers(datasetForLayersIndex);
              }
            )
          );
      } else {
        this.openSnackBarError('MAP.PHOTOGRAM.JOB_FAILED');
        this.removeFromDatasetForLayers(datasetForLayersIndex);
      }
    } else if (
      value &&
      value.status === 'processing' &&
      datasetForLayersIndex !== -1 &&
      this.generatingTransforms.findIndex((id) => id === this.mapService.datasetForLayers[datasetForLayersIndex].id) === -1
    ) {
      // if user refresh the page then add them
      this.generatingTransforms.push(this.mapService.datasetForLayers[datasetForLayersIndex].id);
    }
  }

  private removeFromDatasetForLayers(datasetForLayersIndex) {
    if (this.debug) {
      console.log('%c map.comp %c removeFromDatasetForLayers()', Constants._purple, Constants._orange, datasetForLayersIndex);
    }
    try {
      this.generatingTransforms.splice(
        this.generatingTransforms.findIndex((d) => d === this.mapService.datasetForLayers[datasetForLayersIndex].id),
        1
      );
      this.mapService.datasetForLayers.splice(datasetForLayersIndex, 1);
    } catch (e) {
      console.log(e);
    }
  }

  // check incoming socket updates

  checkSocketTaskUpdate(value) {
    if (!value.dataset.id) return;
    let datasetForLayersIndex = this.mapService.datasetForLayers.findIndex((d) => d.id === value.dataset.id);

    if (this.debug) {
      console.log('%c map.comp %c checkSocketTaskUpdate()', Constants._purple, Constants._orange, value, datasetForLayersIndex);
    }

    if (value.status === 'started' && datasetForLayersIndex !== -1) {
      this.generatingTransforms.push(
        this.mapService.datasetForLayers[this.mapService.datasetForLayers.findIndex((d) => d.id === value.dataset.id)].id
      );
    } else if (
      value.status === 'processing' &&
      datasetForLayersIndex !== -1 &&
      this.generatingTransforms.findIndex((id) => id === this.mapService.datasetForLayers[datasetForLayersIndex].id) === -1
    ) {
      // if user refresh the page then add them
      this.generatingTransforms.push(value.dataset.id);
    } else if (value.status === 'finished' && datasetForLayersIndex !== -1) {
      this.addTransformsToSceneFromTaskResult(value, datasetForLayersIndex);
    } else if (value.status === 'error' && datasetForLayersIndex !== -1) {
      this.removeFromDatasetForLayers(datasetForLayersIndex);
      this.openSnackBarError('GENERIC_ERROR3' + value.info);
    }
  }

  private addTransformsToSceneFromTaskResult(value, datasetForLayersIndex) {
    // if laz file is finished then add it to the scene result
    if (value.dataset.name.endsWith('.laz') || value.dataset.name.endsWith('.las') || value.dataset.name.endsWith('.e57')) {
      // if we need to add the result to the current scene then we need to refresh the scene
      if (
        this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group'] &&
        this.mapService.scene.id === this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group']
      ) {
        this.fourD.V.searchByObject(Transform)
          .equals('input', value.dataset.id)
          .limit(983)
          .queryObservable()
          .subscribe((t) => {
            if (t.items.length > 0) {
              this.mapService.scene.addChildren(t.items).subscribe((_) => {
                if (this.mapService.scene) {
                  // to refresh the photo count once the upload is finished
                  this.mapService.scene.fetchObservable().subscribe();
                  this._loadScene(this.mapService.scene.id, true);
                }
              });
            }
          });
        this.removeFromDatasetForLayers(datasetForLayersIndex);
      } else if (this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group']) {
        // the result is for other scene so add it to that scene
        this.fourD.V.searchByObject(TransformGroup)
          .equals('id', this.mapService.datasetForLayers[datasetForLayersIndex]['for_transform_group'])
          .limit(984)
          .queryObservable()
          .subscribe(
            (tg) => {
              if (tg.items.length > 0) {
                this.fourD.V.searchByObject(Transform)
                  .equals('input', value.dataset.id)
                  .limit(985)
                  .queryObservable()
                  .subscribe((t) => {
                    if (t.items.length > 0) {
                      tg.items[0].addChildren(t.items).subscribe((_) => this.openSnackBarSuccess('MAP.TERRAIN.LAZ_RESULT'));
                    }
                  });
              }
              this.removeFromDatasetForLayers(datasetForLayersIndex);
            },
            (error1) => {
              console.log(error1);
              this.removeFromDatasetForLayers(datasetForLayersIndex);
            }
          );
      }
    } else if (this.mapService.scene) {
      // to refresh the photo count once the upload is finished
      this.mapService.scene.fetchObservable().subscribe();
      this._loadScene(this.mapService.scene.id, true);
      this.removeFromDatasetForLayers(datasetForLayersIndex);
    }
  }

  public waitForPhotogrammetryJobResult() {
    if (this.debug) {
      console.log('%c map.component :: waitForPhotogrammetryJobResult()', Constants._orange);
    }
  }

  togglePhotoBucket() {
    if (this.photosNav.opened) {
      this.closePhotoBucket();
    } else {
      this.openPhotoBucket();
    }
  }

  openPhotoBucket() {
    this.photosNav.open();
    // this.imageComp.showHideAllPhotos(true);
  }

  closePhotoBucket() {
    this.photosNav.close();
    // this.imageComp.showHideAllPhotos(false);
  }

  checkPhotobucket(currentState: boolean) {
    if (this.photosNav.opened) {
      this.imageComp.filterAndRefreshTargetedPhotos();
    }
    if (!currentState && !this.mapService.showPhotos[this.mapService.scene.id]) {
      this.mapService.showPhotos[this.mapService.scene.id] = true;
      this.imageComp.showHideAllPhotos(true);
      this.imageComp.filterAndRefreshTargetedPhotos();
    }
  }

  private openBrowseTTOfLayerComponent(sceneId: number) {
    if (this.mapService.scene && this.mapService.scene.id === sceneId) this.layerComp.browseTT(this.mapService.scene);
    else {
      // console.log('scene not found waiting')
      let sceneSub = this.mapService.onSceneChange('mapComponent').subscribe((scene) => {
        if (scene.id === sceneId) {
          // console.log('scene found ');
          this.layerComp.browseTT(this.mapService.scene);
          sceneSub.unsubscribe();
        }
      });
    }
  }

  fetchDatasetForManualTiling(folder: Folder) {
    if (this.debug) {
      console.log('%c map.comp %c fetchDatasetForManualTiling()', Constants._purple, Constants._orange, folder);
    }

    this.fourD.V.searchByObject(Dataset)
      .equals('folder', folder)
      .limit(986)
      .queryObservable()
      .subscribe((value) => {
        let objForManualTiling = value.items.filter(
          (v) =>
            (!v.transformIds || v.transformIds.length === 0 || (v.transformIds.length === 1 && !v.transformIds[0])) &&
            v.name.endsWith('.obj') &&
            !v['resultAddedToScene']
        );

        let lazForManualTiling = value.items.filter(
          (v) =>
            (!v.transformIds || v.transformIds.length === 0 || (v.transformIds.length === 1 && !v.transformIds[0])) &&
            (v.name.endsWith('.laz') || v.name.endsWith('.las') || v.name.endsWith('.e57')) &&
            v.dataType &&
            !v['resultAddedToScene']
        );

        if (this.debug) {
          console.log('map.comp :: fetchDatasetForManualTiling() value', value, objForManualTiling, lazForManualTiling);
        }

        /*let toAddTransforms = value.items.filter(v => (v.transformIds && v.transformIds.length > 0 && v.transformIds[0] &&
        (v.name.endsWith('.obj') || v.name.endsWith('.laz') || v.name.endsWith('.las')) && !v.incomplete)
      );
      if (toAddTransforms.length > 0) {
        let needToReloadScene = false;
        toAddTransforms.forEach(dataset => {
          if (!this.mapService.sceneTransforms.find(st => st.id === dataset.transformIds[0])) {
            needToReloadScene = true;
            this.mapService.scene.children.addObserveable(new Transform(this.fourD.V).set(
              {id: dataset.transformIds[0]},
            ));
            this.mapService.scene['layerProps'][MapService.TOGGLE + dataset.transformIds[0]] = true;
            this.mapService.scene['layerProps'][MapService.ALPHA + dataset.transformIds[0]] = 1;
            this.mapService.scene.saveObservable().subscribe();
          }
        });
        if (needToReloadScene) {
          this.mapService.loadScene(this.mapService.scene.id).subscribe();
        }
      }*/

        if (objForManualTiling && objForManualTiling.length > 0) {
          this.checkUploadRunningOrTillingForDatasets(objForManualTiling);
          this.getJobData(objForManualTiling);
        }
        if (lazForManualTiling && lazForManualTiling.length > 0) {
          this.checkUploadRunningOrTillingForDatasets(lazForManualTiling);
        }
        let lazDatasets = value.items.filter(
          (v) =>
            !(!v.transformIds || v.transformIds.length === 0 || (v.transformIds.length === 1 && !v.transformIds[0])) &&
            (v.name.endsWith('.laz') || v.name.endsWith('.las') || v.name.endsWith('.e57')) &&
            v.dataType &&
            !v['resultAddedToScene']
        );
        if (lazDatasets.length > 0) {
          this.getLazResult(lazDatasets);
        }
      });
  }

  private getLazResult(lazForManualTiling: Dataset[]) {
    lazForManualTiling.forEach((dataset) => {
      if (dataset['for_transform_group'] && this.mapService.scene.id === dataset['for_transform_group']) {
        this.fourD.V.searchByObject(Transform)
          .equals('input', dataset.id)
          .limit(987)
          .queryObservable()
          .subscribe((t) => {
            if (t.items.length > 0) {
              this.mapService.scene.addChildren(t.items).subscribe((_) => {
                if (this.mapService.scene) {
                  // to refresh the photo count once the upload is finished
                  this.mapService.scene.fetchObservable().subscribe();
                  this._loadScene(this.mapService.scene.id, true);
                }
              });
            }
            this.setResultAddedToScene(dataset);
          });
      } else if (dataset['for_transform_group']) {
        // the result is for other scene so add it to that scene
        this.fourD.V.searchByObject(TransformGroup)
          .equals('id', dataset['for_transform_group'])
          .limit(988)
          .queryObservable()
          .subscribe(
            (tg) => {
              if (tg.items.length > 0) {
                this.fourD.V.searchByObject(Transform)
                  .equals('input', dataset.id)
                  .limit(989)
                  .queryObservable()
                  .subscribe((t) => {
                    if (t.items.length > 0) {
                      tg.items[0].addChildren(t.items).subscribe();
                    }
                    this.setResultAddedToScene(dataset);
                  });
              }
            },
            (error1) => {
              console.log(error1);
            }
          );
      }
    });
  }

  private setResultAddedToScene(dataset) {
    // set resultAddedToScene to the dataset so next time this dataset will be filtered from the list and won't show in the layers.
    dataset['resultAddedToScene'] = true;
    dataset.saveObservable().subscribe();
    // this.incomingData.remove(dataset);
    this.mapService.datasetForLayers = this.mapService.datasetForLayers.filter((ds) => ds.id !== dataset.id);
  }

  // get the dataset's job transforms and if present then add to the scene
  private getJobData(objDatasets: Dataset[]) {
    let observables = objDatasets
      .filter((dataset) => dataset['currentJob'])
      .map((dataset) =>
        this.fourD.V.searchByObject(Job).equals('id', dataset['currentJob']).equals('current', null).limit(990).queryObservable()
      );
    if (observables.length > 0) {
      Constants.showHangOn();
      forkJoin(observables).subscribe((jobs) => {
        if (jobs && jobs.length > 0) {
          // console.log(jobs)
          if (this.debug) {
            console.log('%c map.comp %c getJobData()', Constants._purple, Constants._orange, jobs);
          }

          let toAdd = [];
          jobs.forEach((job) => {
            if (job.items.length > 0 && job.items[0]['transforms']) {
              job.items[0]['transforms'].forEach((transform) => {
                if (transform && transform.id) {
                  toAdd.push(this.mapService.scene.children.addObserveable(new Transform(this.fourD.V).set({ id: transform.id })));
                  this.mapService.scene['layerProps'][MapService.TOGGLE + transform.id] = true;
                  this.mapService.scene['layerProps'][MapService.VIEW + transform.id] = true;
                  this.mapService.scene['layerProps'][MapService.ALPHA + transform.id] = 1;
                  this.mapService.scene.saveObservable().subscribe();
                  // set resultAddedToScene to the dataset so next time this dataset will be filtered from the list and won't show in the layers.
                  let toUpdateDatasetIndex = this.mapService.datasetForLayers.findIndex((ds) => ds['currentJob'] === job.items[0].id);
                  if (toUpdateDatasetIndex !== -1) {
                    let toUpdateDataset = this.mapService.datasetForLayers[toUpdateDatasetIndex];
                    toUpdateDataset['resultAddedToScene'] = true;
                    toUpdateDataset.saveObservable().subscribe();
                  }
                  this.mapService.datasetForLayers = this.mapService.datasetForLayers.filter((ds) => ds['currentJob'] !== job.items[0].id);
                }
              });
            }
          });
          if (toAdd.length) {
            forkJoin(toAdd).subscribe((_) => {
              this.mapService.scene.fetchObservable().subscribe();
              this.layerComp.refreshGroups();
              Constants.hideHangOn();
            });
          } else {
            Constants.hideHangOn();
          }
        } else {
          Constants.hideHangOn();
        }
      });
    }
  }

  // stuff for resizing the sidebar

  /*
  sidenavElement:any = null;
  dragging:boolean = false;

  canvasSizerDoing ( e:any = null ) {
    if ( ! this.dragging ) {
      return;
    }
    let pos = this.sidenavElement.getBoundingClientRect();
    // let top = pos.top;
    let left = pos.left;
    // let height = e.clientY - top;
    let width = e.clientX - left;
    // if ( width < 170 ) { width = 170; }
    // else if ( width > 500 ) { width = 500; }
    // .sidenavElement.style.height = Math.round(height) + 'px';
    this.sidenavElement.style.width = Math.round(width) + 'px';
    // console.log('@@@ doing',top,left,height, width, e);
  }

  canvasSizerDo ( e:any = null ) {
    let find = document.getElementById("sidenav");
    if ( find ) {
      this.sidenavElement = find;
      this.dragging = true;
    }
  }

  canvasSizerDone ( e:any = null ) {
    this.dragging = false;
  }
  */

  _loadScene(id: number, force: boolean) {
    this.v2DataService.scene.value = this.v2DataService.scenes.values.find((s) => s.id == id);
    return this.sceneController.loadScene(id, force);
  }
}

/* 

  Ok, the way I think these TBA components work is that they are created by the router in index.ts;

    {path: ':tabId', component: TBAComponent, pathMatch: 'full'},
    {path: '**', component: TBAComponent}

  All they do is that if the path contains a certain id, for example, 'layers', then the TBA 
  component calls mapComponent to switch the tab view to it. If the id isn't found, the tab won't
  select a view. Default 'layers' only works for a blank route, not for a misspelled or non-existant one.

  Time for a refactor of this ...

*/
@Component({
  selector: 'tba-comp',
  template: `<p class="text-center">{{ 'GENERIC.TODO' | translate }}</p>`,
})
export class TBAComponent implements OnDestroy {
  sub: Subscription[] = [];

  constructor(mapComp: MapComponent, route: ActivatedRoute, ms: MapService) {
    //  console.log( '%c TBA :: constructor()', Constants._green, route.snapshot.params, this, mapComp, route, ms );

    mapComp.detailsNav.close();

    this.sub.push(
      route.params.subscribe((p) => {
        // console.log( '%c TBA :: sub -> params',Constants._green, p);
        if (p.tabId) {
          this.sub.push(
            ms.onReady().subscribe((s) => {
              // console.log( '%c TBA :: sub -> mapService.onReady()',Constants._green, route.snapshot.params, p);
              // console.log(p.tabId);
              // because of local coordinates the sequence of loading scene is changed so once scene is ready we process

              let sb = ms
                .onSceneChange('TBAComponent')
                .pipe(take(1))
                .subscribe((_) => {
                  mapComp.setTab(route.snapshot.params.tabId);
                  // console.log( '%c TBA :: sub -> mapService.onReady() -> onSceneChange()',Constants._green, route.snapshot.params, p );
                  // sb.unsubscribe();
                });
            })
          );
        }
      })
    );
  }

  // @HostListener('unloaded')
  ngOnDestroy(): void {
    // console.log ( '%c TBA ngOnDestroy()', Constants._green );
    this.sub.forEach((s) => s.unsubscribe());
  }
}
